var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotPassTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59_4606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(-180 20 20)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59_4606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25765 13.1843C2.44507 13.246 2.57001 13.246 2.69495 13.246C2.63248 13.246 2.75742 13.246 2.69495 13.246H7.31781V16.7045C7.31781 17.5074 7.94252 18.125 8.75464 18.125H10.6288C10.8787 18.125 11.0036 18.0632 11.191 18.0015C11.4409 17.9397 11.6283 17.7544 11.8157 17.5692L15.0642 13.4313H17.3132C18.1253 13.3696 18.75 12.752 18.75 11.9491V3.92045C18.75 3.11759 18.1253 2.5 17.3132 2.5H5.25626C4.94391 2.5 4.63155 2.62352 4.38167 2.80879C4.13178 2.99407 4.00684 3.24111 3.94437 3.48814L1.32059 11.3933C1.07071 12.1961 1.508 12.999 2.25765 13.1843ZM16.1887 5.27915V10.5904H15.0642V5.27915H16.1887ZM12.4404 5.27915V12.0726L10.129 15.0371V11.8256C10.129 11.0227 9.50429 10.4051 8.69217 10.4051H4.63155L6.31827 5.27915H12.4404Z",
    fill: "#C63838"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPassTest);
export default __webpack_public_path__ + "static/media/not_pass_test.ff333cd3669934e29c030f6c269518cf.svg";
export { ForwardRef as ReactComponent };